import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ChatBot from "./chatBot";

const ChatbotLayout = () => {
  const location = useLocation();
  const [showChatBot, setShowChatBot] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && location.pathname !== "/") {
      setShowChatBot(false);
    } else {
      setShowChatBot(false);
    }
  }, [location]);

  return (
    <>
      <Outlet />
      {showChatBot && <ChatBot />}
    </>
  );
};

export default ChatbotLayout;
